export default "__VITE_ASSET__2fWAA347__"